import React from 'react';
import { ISelectOption } from '../../../domain/saved-filters/interface';
import { BaseFilterCheckboxSelect } from '../base/BaseFilterCheckboxSelect';

interface IUserFilterSelectProps {
    value: number[] | undefined;
    onChange: (value: number[]) => void;
    options: ISelectOption<number>[];
    label?: string;
    disabled?: boolean;
    isLoading?: boolean;
}

export const UserFilterSelect: React.FC<IUserFilterSelectProps> = ({ disabled = false, value = [], onChange, label, options, isLoading }) => {
    return (
        <BaseFilterCheckboxSelect
            resizable
            searchable
            multiple
            showSelectAllOption={false}
            selectedCountInLabel
            showClear
            options={options}
            value={value}
            onChange={onChange}
            label={label}
            disabled={disabled}
            loading={isLoading}
            height={300}
        />
    );
};
